/**
 * Escaping for text that goes into markup.
 *
 * Every screen is built by interpolating into template literals and assigning
 * to innerHTML, so any string from the API that is *text* — a name, a title, a
 * city, a caption — has to be escaped on the way in. Names and bios are written
 * by participants themselves, which makes this the difference between a profile
 * and a stored script.
 *
 * What must NOT pass through here: fields the server already rendered to markup
 * (body_html, mission_html, the island code). Those are built by lib/Markdown.php,
 * which escapes before it formats, and escaping them again would print tags.
 */

const ENTITIES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}

/**
 * Text, safe in element content and inside a quoted attribute. Null and
 * undefined become an empty string so callers can interpolate optional fields
 * without guarding every one.
 */
export function text(value) {
  if (value === null || value === undefined) {
    return ''
  }

  return String(value).replace(/[&<>"']/g, (character) => ENTITIES[character])
}
